if (customElements.get('menu-opener') === undefined) {
  class MenuOpener extends HTMLElement {
 
    constructor() {
      super();
      this.header = document.querySelector('.header-bar');
      this.document = document.documentElement;
    }

    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        this.header.classList.toggle('is-nav-open');
        this.document.classList.toggle('no-scroll');
        let height = this.header.offsetHeight;
        console.log(`Header height: ${height}px`);
        this.document.style.setProperty(
            "--mobnav-height",
            `calc(1vh * 100 - ${height}px)`
        );
      });
    }

    disconnectedCallback() {
    }

    attributeChangedCallback(name, oldVal, newVal) {

    }

    adoptedCallback() {
    }

  }
  customElements.define('menu-opener', MenuOpener);
}

if (customElements.get('meganav-opener') === undefined) {
  class MeganavOpener extends HTMLElement {
 
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        //this.parentElement.classList.toggle('is-meganav-open');
        this.toggle();
      });
      this.bindCloseButton();
    }

    disconnectedCallback() {
    }

    attributeChangedCallback(name, oldVal, newVal) {

    }

    adoptedCallback() {
    }

    bindCloseButton() {
      this.onClose = this.onClose.bind(this);
      this.nextElementSibling.querySelector('.js-meganav-trigger-close').addEventListener('click', this.onClose);
    }

    toggle() {
      this.parentElement.classList.toggle('is-meganav-open');
    }

    onClose() {
      this.toggle();
    }

  }
  customElements.define('meganav-opener', MeganavOpener);
}

// init FlickityResponsive - video carousel has different settings for 1023px and below
if(document.querySelector('.video-carousel__carousel .carousel')) {
    const carousel = new FlickityResponsive('.video-carousel__carousel .carousel', {
      pageDots: false,
      responsive: [
          {
              breakpoint: 1023,
              settings: {
                  contain: false, 
                  wrapAround: true
              }
          }
      ]
  });
}

/* ==========================================================================
# Custom Pixel events
========================================================================== */

window.addEventListener("load", function(){

  // Amazon link button
  const amazon_buttons = document.querySelectorAll('.amazon-button');
  [...amazon_buttons].map((button) => {
    button.addEventListener('click', () => {
      Shopify.analytics.publish('amazon_click',{ click_destination: button.getAttribute('href') }); // Analytics event for Amazon button click
    });
  });

  //Form submit
  const forms = document.querySelectorAll('form');
  [...forms].map((form) => {
    form.addEventListener('submit', () => {
      Shopify.analytics.publish('form_submitted',{form_id: 'id'}); // Analytics event for form submission
    });
  });

  //HTML5 video play
  const videos = document.querySelectorAll('video-thumbnail button');
  [...videos].map((video) => {
    video.addEventListener('click', () => {
      Shopify.analytics.publish('video_played',{}); // Analytics event for video play
    });
  });

}); 